import { render, staticRenderFns } from "./LastImages.vue?vue&type=template&id=062c0d58"
import script from "./LastImages.vue?vue&type=script&lang=js"
export * from "./LastImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports